import { render, staticRenderFns } from "./GalleryWidget.vue?vue&type=template&id=9a388158&"
import script from "./GalleryWidget.vue?vue&type=script&lang=js&"
export * from "./GalleryWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports